const singleLineEmptyQuery = {
  query: "",
  tokens: []
};

export { singleLineEmptyQuery };
//# sourceMappingURL=singleLineEmptyQuery.js.map
